export default __webpack_public_path__ + "static/media/triangle-shape.0a43ba62.svg";